export default "../css/b7bcc075b395c14ce8c2d75dcd5fabe5.woff2";